import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { CompanyService } from '../../../services/company.service';
import { LocationService } from '../../../services/location.service';
import { HttpClient, HttpHandler } from '@angular/common/http';


@Component({
  selector: 'app-location-picker',
  templateUrl: './location-picker.component.html',
  styleUrls: ['./location-picker.component.scss']
})
export class LocationPickerComponent implements OnInit, OnChanges {
  @Input() companyId: number;
  @Input() locationId: number;
  @Input() userLocationIds: number[];
  @Input() disable: boolean = false;
  @Input() _placeholder: string = 'Please Select';
  @Output() onLocationIdSet = new EventEmitter<number>();
  @Output() onLocationSet = new EventEmitter<any>();

  locations = [];
  locationList = [];
  location_Name: string;
  basePlaceholder: string;
  constructor(public locationService: LocationService, public companyService: CompanyService) {
  }

  ngOnInit(): void {
    this.basePlaceholder = this._placeholder;
    this.locationService.getAll(this.companyId).then((locations) => {
      this.locationList = locations;
      this.locations = locations;

      if (this.companyId != null && this.companyId != undefined) {
        this.locations = this.locationList.filter(c => {
          return c.companyId == this.companyId;
        });


      }

      if (this.locationId != undefined && this.locationId != undefined) {
        var location = this.locationList.find(a => a.id == this.locationId);
        this.location_Name = location.name;
        this._placeholder = location.name;

      }
    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    //console.log(changes);

    if ((changes.locationId != null && changes.locationId.currentValue != null) || (changes.companyId != null && changes.companyId.currentValue != null)) {
      if (changes.locationId != null && this.locationId != changes.locationId.currentValue != null)
        this.locationId = changes.locationId.currentValue;
      if (changes.companyId != null && this.companyId != changes.companyId.currentValue != null)
        this.companyId = changes.companyId.currentValue;

      if (this.companyId != null && this.companyId != undefined) {
        this.locations = this.locationList.filter(c => {
          return c.companyId == this.companyId;
        });

      } else {
        this.locations = this.locationList;
        if (this.locationId != undefined && this.locationId != null) {

          if (this.locationList != null) {
            var location = this.locationList.find(a => a.id == this.locationId);
            if (location != undefined && location != null) {
              this.location_Name = location.name;
              this._placeholder = location.name;
            }
          }

        }
      }

    }

    if (changes != undefined && changes.locationId == undefined && changes.companyId != undefined && changes.companyId.currentValue == undefined) {
      this.locationService.getAll(null).then((data) => {
        this.locationList = data;
        this.locations = this.locationList;

        if (this.locationId != undefined && this.locationId > 0) {
          var location = this.locationList.find(a => a.id == this.locationId);
          this.location_Name = location.name;
          this._placeholder = location.name;
        }
        // this.updateClientPreferences();
      });
    }

    if (changes != null && changes.userLocationIds != undefined && changes.userLocationIds != null && changes.userLocationIds.currentValue != null) {
      if (this.locationList != undefined) {
        // this.updateClientPreferences();
      }
    }
  }

  onChanged(location) {
    if (location) {
      this.onLocationIdSet.emit(location.id);
      this.onLocationSet.emit(location);
    } else {
      // this._placeholder = this.basePlaceholder;
      // //console.log(this._placeholder);
    }

  }



  // onChanged(company) {
  //   if (company != null) {
  //     this.onCompanyIdSet.emit(company.id);
  //   } else {
  //     this.onCompanyIdSet.emit(null);
  //   }
  //   this.onCompanySet.emit(company);
  // }
}
